import React from 'react'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'components/Luxkit/Typography/Heading'
import { rem } from 'polished'
import styled from 'styled-components'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import Image from 'components/Common/Image/Image'
import Pane from 'components/Common/Pane'
import clsx from 'clsx'
import { themeClassName } from 'lib/theme/themeUtils'

const Root = styled(Pane)`
  background-color: ${props => props.theme.palette.neutral.default.eight};

  &.background-color-white {
    background-color: ${props => props.theme.palette.neutral.default.eight};
  }

  &.background-color-grey {
    background-color: ${props => props.theme.palette.neutral.default.seven};
  }
`

const StyledContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)}; 
  padding-bottom: ${rem(40)};
  background-color: ${props => props.theme.palette.neutral.default.eight};

  &.background-color-white {
    background-color: ${props => props.theme.palette.neutral.default.eight};
  }

  &.background-color-grey {
    background-color: ${props => props.theme.palette.neutral.default.seven};
  }
`

const LogoCarousel = styled(CardCarousel)`
  margin-top: ${rem(24)};
`

const LogoWrapper = styled.div`
  padding: ${rem(8)} ${rem(16)};
  display: flex;
  align-items: center;
  justify-content: center;

  &.with-outline {
    border: 1px solid ${props => props.theme.palette.neutral.default.five};
  }
`

const PAGE_SIZE = 8

function ContentfulLogosCarousel(props: App.ComponentLogoCarousel) {
  return <Root className={clsx(`background-color-${props.backgroundColor}`, themeClassName(props.backgroundColor === 'dark' ? 'inverse' : 'default'))}>
    <StyledContainer className={clsx(`background-color-${props.backgroundColor}`, themeClassName(props.backgroundColor === 'dark' ? 'inverse' : 'default'))}>
      <Heading variant="heading3" dangerouslySetInnerHTML={{ __html: props.title }}/>
      <LogoCarousel pageSize={PAGE_SIZE} gap={12}>
        {props.images.map((image) => (
          <LogoWrapper className={clsx(`background-color-${props.backgroundColor}`, { 'with-outline': props.withOutline }, themeClassName(props.backgroundColor === 'dark' ? 'inverse' : 'default'))} key={image.title}>
            <Image width={80} image={image} alt={image.title} />
          </LogoWrapper>
        ))}
      </LogoCarousel>
    </StyledContainer>
  </Root>
}

export default ContentfulLogosCarousel
